// GIS utilities — geocoding proxied through Cloudflare Worker

import { WORKER_URL } from '../../../lib/api-switch';

const WORKER = WORKER_URL;

export async function getCountyFromCoords(lat: number, lng: number) {
  try {
    const res = await fetch(
      `https://geo.fcc.gov/api/census/block/find?latitude=${lat}&longitude=${lng}&format=json`
    );
    const data = await res.json();
    if (data?.County) {
      return {
        county: data.County.name as string,
        fipsCode: data.County.FIPS as string,
        state: (data.State?.name || '') as string,
        stateCode: (data.State?.code || '') as string,
      };
    }
    return null;
  } catch (err) {
    console.error('County lookup error:', err);
    return null;
  }
}

export async function reverseGeocode(lat: number, lng: number) {
  try {
    const res = await fetch(
      `${WORKER}/api/nominatim/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1`,
      { headers: { 'Accept': 'application/json' } }
    );
    const data = await res.json();
    if (data?.address) {
      const a = data.address;
      return {
        address: data.display_name as string,
        street: [a.house_number, a.road].filter(Boolean).join(' '),
        city: (a.city || a.town || a.village || '') as string,
        state: (a.state || '') as string,
        zip: (a.postcode || '') as string,
        county: (a.county || '') as string,
      };
    }
    return null;
  } catch (err) {
    console.error('Reverse geocode error:', err);
    return null;
  }
}

export async function geocodeAddress(address: string) {
  try {
    const res = await fetch(
      `${WORKER}/api/nominatim/search?q=${encodeURIComponent(address)}&format=json&limit=1&addressdetails=1&countrycodes=us`,
      { headers: { 'Accept': 'application/json' } }
    );
    const data = await res.json();
    if (data?.[0]) {
      return {
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon),
        address: data[0].display_name as string,
        county: (data[0].address?.county || '') as string,
      };
    }
    return null;
  } catch (err) {
    console.error('Geocode error:', err);
    return null;
  }
}
